import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-box',
  imports: [NgClass, CommonModule, TranslateModule],
  templateUrl: './notification-box.component.html',
  styleUrl: './notification-box.component.scss'
})
export class NotificationBoxComponent {
  @Input() type: 'success' | 'error' = 'success';
  @Input() message: string = '';
  @Output() closed = new EventEmitter<void>();

  close() {
    this.closed.emit();
  }
}
